<template>
  <div class="duration" v-if="isVideoBg" @click="onClick();report('durationSetting');report('durationSetting2')">
    <div>
      视频时长：{{ startFormat }} - {{ endFormat }} {{durationFormat && '/'}} {{durationFormat}}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatSecond } from '@/plugins/formatDuration';
import reporter from '@/components/mixins/analysis/sceneBgSetting';

export default {
  mixins: [reporter],
  data () {
    return {
      startTime: 0,
      endTime: 0,
      startFormat: '',
      endFormat: '',
      isVideoBg: false,
      duration: 0,
      durationFormat: ''
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg'
    ]),
    ...mapGetters({
      openSubtitle: 'subtitle/openSubtitle'
    }),
  },
  watch: {
    TOOL (val) {
      if (val) {
        this.TOOL.eve.on('sceneBgAdded', this.render);
      }
    },
    'SelectScenes_Msg': {
      handler (val) {
        let { videoStartTime, videoEndTime, type } = val.background.data;
        if (type !== 'Video') {
          this.isVideoBg = false;
          return;
        }

        this.durationFormat = '';
        this.render();
      },
      // immediate: true
    },
    'SelectScenes_Msg.data': {
      handler (val, oldVal) {
        if (!val) {
          return;
        }
        if (val.videoStartTime !== oldVal.videoStartTime || val.videoEndTime !== oldVal.videoEndTime) {
          this.render();
        }
      },
      deep: true
    },
  },
  created () {
    eve.on("sceneBgAdded", this.render);

    eve.on('videoBgDurationUpdated', this.render);

    // this.$bus.on('durationTip.update', this.render);

    this.$bus.on('bgSetting.buttonClicked', ({name} = {}) => {
      if (name === 'duration') {
        this.onClick();
      }
    })
  },
  mounted () {

  },
  methods: {
    render () {
      if (!this.SelectScenes_Msg || !this.SelectScenes_Msg.background) {
        return;
      }
      let { videoStartTime, videoEndTime, type } = this.SelectScenes_Msg.background.data;
      if (type !== 'Video') {
        this.isVideoBg = false;
        return;
      }

      this.isVideoBg = true;

      this.startTime = videoStartTime || 0;
      this.endTime = videoEndTime || 0;
      this.startFormat = formatSecond(this.startTime);
      this.endFormat = formatSecond(this.endTime);

      this.$util
        .getMediaDuration(this.$handleAssetsUrl(this.SelectScenes_Msg.background.data.data.url))
        .then((dur) => {
          this.duration = dur;
          this.durationFormat = formatSecond(this.duration);

          this.endTime = Math.min(this.duration, this.endTime);
          this.endFormat = formatSecond(this.endTime);
        });
    },

    onClick () {
      let { $el } = this;
      let rect = $el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'clipSetting.bg',
        type: 1,
        initialX: rect.left,
        initialY: rect.top - 202 - 4,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.duration {
  padding: 10px;
  // width: 180px;
  background-color: rgba(#000, 0.5);
  border-radius: 4px;
  color: white;
  white-space: nowrap;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/tool/bgSettingBtn/duration.vue